import { FC, useEffect } from 'react';
import { AddButton } from '../../../../../lib/components/Buttons/AddButton';
import { CellStyle } from '../../../../../lib/components/DataTable/CellStyle';
import { DataTable } from '../../../../../lib/components/DataTable/DataTable';
import { useRequestFeedback } from '../../../../../lib/hooks';
import { Tag } from '../../../../../lib/model/Tag';
import { useTagsManagementApi } from '../../hooks/ContractTagsApi';
import { UpdateButton } from '../../../../../lib/components/Buttons/UpdateButton';
// import { RemoveButton } from '../../../../../lib/components/Buttons/RemoveButton';

interface IProps {
	book_series: Tag[];
	on_remove_success: () => void;
	visible_insert_modal: () => void;
	set_current_update_id?: (data: Tag | undefined) => void;
}

export const BookSeriesDatatable: FC<IProps> = ({
	book_series,
	on_remove_success,
	visible_insert_modal,
	set_current_update_id,
}) => {
	const { remove } = useTagsManagementApi('book');

	useEffect(() => {
		if (remove.result) {
			on_remove_success();
		}
	}, [remove.result]);

	useRequestFeedback(remove.result, remove.error);

	// ✅ Ordena alfabeticamente por título (ignorando acentuação e maiúsculas/minúsculas)
	const sortedSeries = [...book_series].sort((a, b) =>
		a.title.localeCompare(b.title, 'pt', { sensitivity: 'base' })
	);

	return (
		<DataTable
			{...{
				rowData: sortedSeries,
				buttons: [
					<AddButton
						key='add'
						onClick={() => {
							set_current_update_id?.(undefined);
							visible_insert_modal();
						}}
					/>,
				],
				columns: [
					{
						field: 'title',
						headerName: 'Título',
						resizable: true,
						rowDrag: false,
						width: 500,
					},
					{
						col_def: {
							field: 'buttons',
							headerName: '',
							pinned: 'right',
							cellStyle: CellStyle.Centered,
							width: 100,
						},
						renderer: (props: { data: Tag }) => (
							<UpdateButton
								onClick={() => {
									if (props?.data && set_current_update_id) {
										set_current_update_id(props?.data);
									}
									visible_insert_modal();
								}}
							/>
							// <RemoveButton
							// 	on_confirm={() => remove.do_remove(props.data.id)}
							// 	title={`Deseja remover a ${props.data.title} de livro?`}
							// />
						),
					},
				],
			}}
		/>
	);
};
